import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { FAQS } from "../mock";

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section className="py-24 bg-[#070d19] border-t border-[rgba(46,155,255,0.1)]">
      <div className="max-w-3xl mx-auto px-5 lg:px-8">
        <div className="text-center reveal">
          <h2 className="font-display text-4xl lg:text-5xl font-bold text-white">Frequently Asked <span className="text-blue-grad">Questions</span></h2>
          <p className="text-slate-400 mt-4">Everything you need to know before you start trading smarter.</p>
        </div>
        <div className="mt-10 space-y-3">
          {FAQS.map((f, i) => (
            <div key={i} className="glass-card rounded-xl overflow-hidden">
              <button onClick={() => setOpen(open === i ? -1 : i)} className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left">
                <span className="text-white font-medium">{f.q}</span>
                {open === i ? <Minus className="w-5 h-5 text-[#2e9bff] shrink-0" /> : <Plus className="w-5 h-5 text-[#2e9bff] shrink-0" />}
              </button>
              <div className={`grid transition-all duration-300 ${open === i ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
                <div className="overflow-hidden">
                  <p className="px-5 pb-5 text-slate-400 text-sm leading-relaxed">{f.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
